
<div class="flex flex-row gap-2">
  <span [ngStyle]="{'color': colorClass}" class="text-m material-symbols-rounded" id="iec-vote-selection-icon" >{{ iconName }}</span>
  <button *ngIf="hasComment" (click)="openPopover(commentPopover)">
    <app-view-votes-popover
      #commentPopover
      id="iec-vote-comment-popover"
      popoverTitle="Ballot Comment"
      [votePopoverItems]="voteCommentPopoverItems"
    ></app-view-votes-popover>

    <span
      [class]="ViewVoteIconsConstants.chatBubble.colorClass"
      class="text-m material-symbols-rounded text-darkBlue-600"
      id="iec-vote-comment-icon"
    >
      {{ ViewVoteIconsConstants.chatBubble.iconName }}
    </span>
  </button>

  <button *ngIf="showingDocumentIcon" (click)="openVoteDocumentsPopover(voteDocumentsPopover)">
    <app-votes-documents-popover
      #voteDocumentsPopover
      id="iec-vote-documents-popover"
      popoverTitle="Authorisation Documents"
      ballotType="{{BallotType}}"
      ballotId="{{vote?.iecBallotId}}"
      voteId="{{vote?.id}}"
    ></app-votes-documents-popover>
    <span
      [class]="ViewVoteIconsConstants.draft.colorClass"
      class="text-blue-500 text-m material-symbols-rounded"
      id="iec-vote-document-icon">
      {{ ViewVoteIconsConstants.draft.iconName }}
    </span>
  </button>

  <span
    *ngIf="hasDocument"
    [class]="ViewVoteIconsConstants.howToVote.colorClass"
    class="text-m material-symbols-rounded text-grey-800"
    id="iec-vote-proxy-vote-icon"
  >
    {{ ViewVoteIconsConstants.howToVote.iconName }}
  </span>

  <button *ngIf="hasHistories" (click)="openPopover(historyPopover)">
    <app-view-votes-popover
      #historyPopover
      id="iec-vote-history-popover"
      popoverTitle="Vote History"
      [votePopoverItems]="voteHistoryPopoverItems"
    ></app-view-votes-popover>
    <span
      [class]="ViewVoteIconsConstants.history.colorClass"
      class="text-m material-symbols-rounded text-grey-800"
      id="iec-vote-history-icon"
    >
      {{ ViewVoteIconsConstants.history.iconName }}
    </span>
  </button>
</div>
